import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const EmployeesModule = lazy(loadModule);

export default EmployeesModule;
